import React, { ComponentProps } from 'react'

import { Box, Loader } from '@surglogs-app/ui'

export const ComponentLoader = (props: ComponentProps<typeof Box>) => (
  <Box {...{ position: 'relative', w: '100%', h: '100%', ...props }}>
    <Loader />
  </Box>
)

export const DefaultComponentLoader = (
  props: ComponentProps<typeof ComponentLoader>,
) => <ComponentLoader {...{ bgc: 'white.100', h: 200, bra: 'sm', ...props }} />
